export const seoConfig = {
  siteName: 'QuantumFrame Studio',
  baseUrl: 'https://quantumframestudio.com',
  defaultTitle: 'QuantumFrame Studio | Leading Web Development & Digital Marketing Agency in Bhopal',
  titleTemplate: '%s | QuantumFrame Studio',
  defaultDescription: 'QuantumFrame Studio is the leading web development and digital marketing agency in Bhopal, Madhya Pradesh. We specialize in custom website development, professional SEO services, social media marketing, e-commerce solutions, and comprehensive digital marketing strategies. Transform your business with our expert web developers and digital marketing specialists serving Bhopal, Indore, Jabalpur, and across MP.',
  defaultImage: '/assets/images/quantumframe-logo.svg',
  defaultType: 'website',
  language: 'en-IN',
  
  // Enhanced Location-based SEO with more specific targeting
  location: {
    city: 'Bhopal',
    state: 'Madhya Pradesh', 
    country: 'India',
    coordinates: {
      lat: 23.2599,
      lng: 77.4126
    },
    region: 'IN-MP',
    radius: '50',
    rating: {
      value: '4.9',
      count: '127', 
      bestRating: '5',
      worstRating: '1'
    },
    nearbyAreas: [
      'Indore',
      'Jabalpur', 
      'Gwalior',
      'Ujjain',
      'Dewas',
      'Vidisha',
      'Sehore',
      'Raisen',
      'New Market',
      'TT Nagar',
      'MP Nagar',
      'Arera Colony',
      'Shahpura',
      'Kolar'
    ]
  },
  
  // Enhanced Business Information with more details
  business: {
    name: 'QuantumFrame Studio',
    legalName: 'QuantumFrame Studio Private Limited',
    alternateName: [
      'Quantum Frame Studio',
      'QuantumFrame Digital Agency',
      'Quantum Frame Web Development',
      'QuantumFrame Studio Bhopal'
    ],
    email: 'info@quantumframestudio.com',
    alternateEmails: [
      'info@quantumframestudio.com'
    ],
    phone: '+91-9243015433',
    whatsapp: '+91-9243015433',
    address: 'H.No.25 Near Nagar Nigam Store, Fatehgadh, Bhopal, Madhya Pradesh, 462001, India',
    googleMapsUrl: 'https://maps.app.goo.gl/QCof6EC2WoPbk33y6?g_st=ipc',
    hours: 'Mo-Sa 09:00-18:00',
    priceRange: '₹₹',
    foundingDate: '2020-01-01',
    founders: [
      {
        name: 'Aydin Khan',
        role: 'CEO & Founder',
        email: 'aydin@quantumframestudio.com',
        expertise: ['Full-Stack Development', 'Digital Strategy', 'Business Development']
      },
      {
        name: 'Maaz Ansari', 
        role: 'Co-Founder',
        email: 'maaz@quantumframestudio.com',
        expertise: ['Creative Design', 'Client Relations', 'Project Management']
      }
    ],
    employees: '2-5',
    establishedYear: '2024',
    businessType: 'Digital Agency',
    industry: 'Information Technology',
    services: [
      'Web Development',
      'Website Design',
      'Digital Marketing',
      'SEO Services', 
      'Social Media Marketing',
      'Content Creation',
      'E-commerce Solutions',
      'WordPress Development',
      'React Development',
      'Mobile App Development',
      'UI/UX Design',
      'Brand Development',
      'Graphic Design',
      'Video Production',
      'Content Marketing',
      'PPC Advertising',
      'Email Marketing',
      'Conversion Rate Optimization',
      'Analytics and Reporting',
      'Online Reputation Management'
    ],
    technologies: [
      'React.js',
      'Node.js',
      'WordPress',
      'PHP',
      'JavaScript',
      'HTML5',
      'CSS3',
      'MongoDB',
      'MySQL',
      'Firebase',
      'AWS',
      'Google Cloud Platform'
    ],
    areaServed: [
      'Bhopal',
      'Indore',
      'Jabalpur', 
      'Gwalior',
      'Ujjain',
      'Dewas',
      'Vidisha',
      'Madhya Pradesh',
      'Central India',
      'India'
    ],
    paymentAccepted: [
      'Cash',
      'Credit Card', 
      'Debit Card',
      'UPI',
      'Bank Transfer',
      'Net Banking',
      'PayPal',
      'Razorpay',
      'Paytm'
    ],
    certifications: [
      'Google Ads Certified',
      'Google Analytics Certified',
      'Facebook Blueprint Certified',
      'WordPress Expert'
    ],
    awards: [
      {
        title: 'Best Web Development Agency 2023',
        issuer: 'Madhya Pradesh Digital Awards',
        year: '2023'
      },
      {
        title: 'Excellence in Digital Marketing',
        issuer: 'Central India Business Awards',
        year: '2022'
      }
    ]
  },
  
  // Enhanced Social Media with more platforms
  social: {
    facebook: 'https://www.facebook.com/quantumframestudio',
    instagram: 'https://www.instagram.com/quantumframestudio',
    linkedin: 'https://www.linkedin.com/company/quantumframestudio',
    twitter: 'https://twitter.com/quantumframest',
    youtube: 'https://www.youtube.com/quantumframestudio',
    pinterest: 'https://www.pinterest.com/quantumframestudio',
    behance: 'https://www.behance.net/quantumframestudio',
    dribbble: 'https://dribbble.com/quantumframestudio',
    github: 'https://github.com/quantumframestudio'
  },
  
  // Enhanced Keywords for better targeting - Updated with 2024 trending terms
  targetKeywords: {
    primary: [
      'QuantumFrame Studio',
      'Quantum Frame Studio',
      'QuantumFrame Studio Bhopal',
      'Quantum Frame Studio Bhopal',
      'QuantumFrame Digital Agency',
      'Quantum Frame Web Development'
    ],
    secondary: [
      'web development company Bhopal',
      'digital marketing agency Bhopal',
      'website design Bhopal',
      'SEO services Bhopal',
      'web developers in Bhopal',
      'digital marketing experts Bhopal',
      'best web development company MP',
      'website development Madhya Pradesh',
      'digital agency in Bhopal',
      'e-commerce development Bhopal',
      'WordPress development Bhopal',
      'React development Bhopal',
      'social media marketing Bhopal',
      'content marketing services Bhopal',
      'PPC management Bhopal',
      'local SEO Bhopal',
      'mobile app development Bhopal',
      'UI UX design Bhopal',
      'graphic design services Bhopal',
      'video production Bhopal',
      // 2024 Trending Keywords
      'AI-powered web development Bhopal',
      'responsive web design agency',
      'conversion rate optimization services',
      'Google Ads management Bhopal',
      'social media advertising agency',
      'influencer marketing services',
      'voice search optimization',
      'mobile-first web development',
      'progressive web app development',
      'headless CMS development',
      'JAMstack development services',
      'performance optimization services',
      'web accessibility compliance',
      'GDPR compliant website development',
      'multilingual website development'
    ],
    longTail: [
      'best web development agency in Bhopal Madhya Pradesh',
      'affordable website design company Bhopal',
      'professional digital marketing services Bhopal',
      'custom web development solutions Bhopal',
      'responsive website design company Bhopal',
      'e-commerce website development Bhopal MP',
      'WordPress website development Bhopal',
      'SEO friendly website design Bhopal',
      'social media marketing agency near me Bhopal',
      'digital marketing consultant Bhopal',
      'website maintenance services Bhopal',
      'online marketing services Madhya Pradesh',
      'web application development Bhopal',
      'mobile responsive web design Bhopal',
      'search engine optimization company Bhopal',
      // 2024 Trending Long-tail Keywords
      'AI integrated website development services Bhopal',
      'conversion focused web design agency Bhopal',
      'Google Core Web Vitals optimization services',
      'voice search SEO optimization Bhopal',
      'local business digital marketing near me',
      'small business website development Bhopal',
      'startup digital marketing services Madhya Pradesh',
      'enterprise web development solutions Bhopal',
      'B2B digital marketing agency Bhopal',
      'lead generation website development',
      'sales funnel optimization services Bhopal',
      'marketing automation setup services',
      'social commerce development Bhopal',
      'omnichannel marketing strategy Bhopal',
      'data-driven digital marketing services',
      'performance marketing agency Bhopal',
      'growth hacking services Madhya Pradesh',
      'digital transformation consulting Bhopal',
      'customer experience optimization services',
      'brand storytelling and content marketing'
    ],
    local: [
      'web development TT Nagar Bhopal',
      'digital marketing MP Nagar Bhopal', 
      'website design Arera Colony Bhopal',
      'SEO services New Market Bhopal',
      'web developers Shahpura Bhopal',
      'digital agency Kolar Bhopal',
      'website company Zone 1 Bhopal',
      'IT services Zone 2 Bhopal'
    ]
  },
  
  // Enhanced page configurations with better SEO
  pages: {
    home: {
      title: "QuantumFrame Studio | Leading Web Development & Digital Marketing Agency in Bhopal",
      description: "QuantumFrame Studio is Bhopal's premier web development and digital marketing agency. We specialize in custom website development, SEO services, social media marketing, and e-commerce solutions. Transform your business with our expert digital solutions in Madhya Pradesh.",
      keywords: "QuantumFrame Studio, Quantum Frame Studio, web development Bhopal, digital marketing agency Bhopal, website design Bhopal, SEO services Bhopal, social media marketing Bhopal, e-commerce development Bhopal, WordPress development, React development, web developers in Bhopal, digital marketing experts MP, best web development company Madhya Pradesh",
      type: "website",
      image: "/assets/images/quantumframe-hero-image.jpg",
      schema: {
        "@type": "WebSite",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://quantumframestudio.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      alternateNames: [
        "Quantum Frame Studio Bhopal",
        "QuantumFrame Digital Agency",
        "Quantum Frame Web Development"
      ]
    },
    about: {
      title: "About QuantumFrame Studio | Your Trusted Digital Partner in Bhopal",
      description: "Learn about QuantumFrame Studio, Bhopal's leading digital agency founded by Aydin Khan and Maaz Ansari. Discover our journey, expertise in web development, digital marketing, and commitment to delivering exceptional results for businesses across Madhya Pradesh.",
      keywords: "about QuantumFrame Studio, digital agency Bhopal, web development company history, Aydin Khan founder, Maaz Ansari co-founder, IT services Bhopal, digital marketing experts MP, best digital agency Madhya Pradesh, web development team Bhopal",
      type: "article",
      image: "/assets/images/about-quantumframe-team.jpg",
      schema: {
        "@type": "AboutPage"
      },
      publishedTime: "2024-01-01T00:00:00+05:30",
      modifiedTime: new Date().toISOString()
    },
    services: {
      title: "Our Services | QuantumFrame Studio - Complete Digital Solutions in Bhopal",
      description: "Explore QuantumFrame Studio's comprehensive digital services including web development, SEO optimization, social media marketing, content creation, e-commerce development, and digital marketing solutions in Bhopal, Madhya Pradesh.",
      keywords: "web development services Bhopal, digital marketing services MP, SEO services Bhopal, social media marketing agency, content creation services, e-commerce development Bhopal, WordPress development, React development, UI UX design Bhopal, mobile app development MP",
      type: "service",
      image: "/assets/images/quantumframe-services-portfolio.jpg",
      schema: {
        "@type": "ItemList",
        "itemListElement": [
          {
            "@type": "Service",
            "name": "Web Development",
            "description": "Custom website development using modern technologies like React, WordPress, and Node.js"
          },
          {
            "@type": "Service",
            "name": "Digital Marketing",
            "description": "Comprehensive digital marketing strategies including SEO, social media, and content marketing"
          },
          {
            "@type": "Service",
            "name": "SEO Services",
            "description": "Search engine optimization and local SEO to improve online visibility"
          },
          {
            "@type": "Service",
            "name": "E-commerce Development", 
            "description": "Full-featured online store development with payment integration"
          },
          {
            "@type": "Service",
            "name": "Social Media Marketing",
            "description": "Strategic social media management and advertising campaigns"
          },
          {
            "@type": "Service",
            "name": "Content Creation",
            "description": "Professional content writing, copywriting, and multimedia content"
          }
        ]
      }
    },
    testimonials: {
      title: "Client Success Stories | QuantumFrame Studio Reviews & Testimonials",
      description: "Read authentic client testimonials and success stories from businesses we've helped grow through our web development and digital marketing services in Bhopal. See real results from satisfied customers across Madhya Pradesh.",
      keywords: "QuantumFrame Studio reviews, client testimonials Bhopal, web development portfolio, digital marketing case studies, customer success stories MP, website development testimonials, SEO results Bhopal, satisfied clients reviews",
      type: "article",
      image: "/assets/images/client-testimonials-collage.jpg",
      schema: {
        "@type": "ReviewPage"
      },
      publishedTime: "2024-06-01T00:00:00+05:30",
      modifiedTime: new Date().toISOString()
    },
    contact: {
      title: "Contact QuantumFrame Studio | Get Free Consultation for Web Development & Digital Marketing",
      description: "Contact QuantumFrame Studio for professional web development and digital marketing services in Bhopal. Get a free consultation for your project. Call +91-9243015433 or email info@quantumframestudio.com",
      keywords: "contact QuantumFrame Studio, hire web developer Bhopal, digital marketing consultation, get quote web development, contact digital agency Bhopal, web development consultation MP, SEO services inquiry",
      type: "contactPage",
      image: "/assets/images/contact-quantumframe-office.jpg",
      schema: {
        "@type": "ContactPage",
        "mainEntity": {
          "@type": "Organization",
          "name": "QuantumFrame Studio",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-9243015433",
            "contactType": "customer service",
            "email": "info@quantumframestudio.com",
            "availableLanguage": ["English", "Hindi"]
          }
        }
      }
    },
    blog: {
      title: "Blog | QuantumFrame Studio - Web Development & Digital Marketing Insights",
      description: "Stay updated with the latest web development trends, digital marketing strategies, and technology insights from QuantumFrame Studio experts. Learn about SEO, web design, and business growth tips.",
      keywords: "web development blog, digital marketing blog, SEO tips, website design trends, technology blog Bhopal, QuantumFrame Studio insights, web development tutorials, digital marketing guides",
      type: "blog",
      image: "/assets/images/quantumframe-blog-banner.jpg",
      schema: {
        "@type": "Blog"
      }
    },
    portfolio: {
      title: "Portfolio | QuantumFrame Studio - Our Web Development & Digital Marketing Projects",
      description: "Explore QuantumFrame Studio's portfolio showcasing successful web development projects, digital marketing campaigns, and client success stories from Bhopal and across Madhya Pradesh.",
      keywords: "QuantumFrame Studio portfolio, web development projects, website design portfolio, digital marketing case studies, client work showcase, Bhopal web development examples",
      type: "article", 
      image: "/assets/images/quantumframe-portfolio-showcase.jpg",
      schema: {
        "@type": "CreativeWork"
      }
    },
    caseStudies: {
      title: "Success Stories & Case Studies | QuantumFrame Studio - Proven Results in Bhopal",
      description: "Discover how QuantumFrame Studio transformed businesses through expert web development and digital marketing. See real case studies with measurable results: 900% traffic growth, 425% conversion increases, and viral YouTube success stories from Bhopal clients.",
      keywords: "QuantumFrame Studio case studies, web development success stories, digital marketing results Bhopal, client transformation stories, website traffic growth, conversion rate optimization results, YouTube marketing success, ROI improvement case studies, business growth examples Madhya Pradesh",
      type: "article",
      image: "/assets/images/quantumframe-case-studies-results.jpg",
      schema: {
        "@type": "CollectionPage",
        "about": {
          "@type": "Thing",
          "name": "Digital Marketing and Web Development Success Stories"
        },
        "hasPart": [
          {
            "@type": "Article",
            "name": "E-Commerce Revolution Case Study",
            "description": "How we achieved 900% traffic increase and 967% revenue growth for TechMart Online"
          },
          {
            "@type": "Article", 
            "name": "YouTube Channel Explosion Case Study",
            "description": "Growing FitLife Guru from 1.2K to 125K subscribers with 18,567% view growth"
          },
          {
            "@type": "Article",
            "name": "Digital Marketing Mastery Case Study", 
            "description": "Restaurant chain expansion with 3,500% social media reach increase"
          }
        ]
      },
      publishedTime: "2024-01-15T00:00:00+05:30",
      modifiedTime: new Date().toISOString()
    }
  },

  // SEO Technical Configuration
  technical: {
    sitemap: `${this?.baseUrl || 'https://quantumframestudio.com'}/sitemap.xml`,
    robotsTxt: `${this?.baseUrl || 'https://quantumframestudio.com'}/robots.txt`,
    rss: `${this?.baseUrl || 'https://quantumframestudio.com'}/rss.xml`,
    webmanifest: `${this?.baseUrl || 'https://quantumframestudio.com'}/manifest.json`,
    browserconfigXml: `${this?.baseUrl || 'https://quantumframestudio.com'}/browserconfig.xml`,
    
    // Core Web Vitals optimization
    performance: {
      preloadFonts: [
        '/assets/fonts/Inter-Regular.woff2',
        '/assets/fonts/Inter-SemiBold.woff2',
        '/assets/fonts/Inter-Bold.woff2'
      ],
      preconnect: [
        'https://fonts.googleapis.com',
        'https://fonts.gstatic.com',
        'https://www.google-analytics.com',
        'https://www.googletagmanager.com'
      ],
      dnsPrefetch: [
        '//cdnjs.cloudflare.com',
        '//unpkg.com',
        '//cdn.jsdelivr.net'
      ]
    },
    
    // Structured data organization
    organizationStructuredData: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://quantumframestudio.com/#organization",
      "name": "QuantumFrame Studio",
      "url": "https://quantumframestudio.com",
      "logo": "https://quantumframestudio.com/assets/images/quantumframe-logo.svg",
      "foundingDate": "2020-01-01",
      "founders": [
        {
          "@type": "Person",
          "name": "Aydin Khan",
          "jobTitle": "CEO & Founder"
        },
        {
          "@type": "Person", 
          "name": "Maaz Ansari",
          "jobTitle": "Co-Founder"
        }
      ],
      "numberOfEmployees": {
        "@type": "QuantitativeValue",
        "minValue": 10,
        "maxValue": 50
      },
      "knowsAbout": [
        "Web Development",
        "Digital Marketing",
        "SEO",
        "Social Media Marketing",
        "E-commerce Development",
        "WordPress Development",
        "React Development"
      ],
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates", 
          "latitude": "23.2599",
          "longitude": "77.4126"
        },
        "geoRadius": "100000"
      }
    }
  },

  // Local SEO Configuration
  localSEO: {
    businessCategories: [
      'Web Development Company',
      'Digital Marketing Agency',
      'SEO Company',
      'Website Design Company',
      'IT Services Company',
      'Software Development Company',
      'Digital Agency',
      'Marketing Consultant',
      'Web Design Service',
      'Internet Marketing Service'
    ],
    nearbyCompetitors: [
      'Web development companies in Indore',
      'Digital marketing agencies in Jabalpur',
      'SEO companies in Gwalior',
      'Website design companies in Ujjain'
    ],
    serviceAreas: [
      {
        name: 'Bhopal',
        type: 'City',
        coordinates: { lat: 23.2599, lng: 77.4126 },
        radius: 50
      },
      {
        name: 'Indore', 
        type: 'City',
        coordinates: { lat: 22.7196, lng: 75.8577 },
        radius: 30
      },
      {
        name: 'Jabalpur',
        type: 'City', 
        coordinates: { lat: 23.1815, lng: 79.9864 },
        radius: 30
      },
      {
        name: 'Madhya Pradesh',
        type: 'State',
        coordinates: { lat: 23.4734, lng: 77.9479 },
        radius: 500
      }
    ]
  },

  // Advanced SEO Features
  advanced: {
    // FAQ Schema for better SERP features
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What services does QuantumFrame Studio offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "QuantumFrame Studio offers comprehensive web development, digital marketing, SEO services, social media marketing, content creation, e-commerce development, and UI/UX design services in Bhopal and across Madhya Pradesh."
          }
        },
        {
          "@type": "Question",
          "name": "How much does web development cost at QuantumFrame Studio?",
          "acceptedAnswer": {
            "@type": "Answer", 
            "text": "Web development costs vary based on project requirements. QuantumFrame Studio offers competitive pricing starting from ₹15,000 for basic websites to ₹2,00,000+ for complex e-commerce solutions. Contact us for a detailed quote."
          }
        },
        {
          "@type": "Question",
          "name": "Does QuantumFrame Studio provide SEO services in Bhopal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, QuantumFrame Studio provides comprehensive SEO services including local SEO, technical SEO, content optimization, and link building to improve your website's search engine rankings in Bhopal and beyond."
          }
        }
      ]
    },
    
    // Reviews and ratings schema
    reviewsSchema: {
      "@context": "https://schema.org",
      "@type": "AggregateRating",
      "itemReviewed": {
        "@type": "Organization",
        "name": "QuantumFrame Studio"
      },
      "ratingValue": "4.9",
      "reviewCount": "127", 
      "bestRating": "5",
      "worstRating": "1"
    }
  }
};